import { Theme } from '@material-ui/core';
import { makeStyles, alpha } from '@material-ui/core/styles';

import { DeviceType } from '../../providers/ViewportProvider';

export const useStyles = makeStyles<Theme, { device: DeviceType }>(
  (theme: Theme) => ({
    root: {
      width: '100%',
      height: 'inherit',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    cardButtonOne: {
      fontWeight: 600,
      fontSize: "16px",
      lineHeight: "20px",
      color: "#FBF7EF",
      background: "#403A30",
      borderRadius: "6px",
      paddingLeft: "28px",
      paddingRight: "28px",
      paddingTop: "11px",
      paddingBottom: "11px"
    },
    cardTitle: {
      fontSize: "34px",
      lineHeight: "44px",
      fontWeight: 600,
      color: "#FBF7EF",
    },
    cardCountdown: {
      fontSize: "10px",
      lineHeight: "12px",
      fontWeight: 500,
      color: "#E1B456",
      borderBottom: "dashed 1px #E1B456",
      paddingTop: "18px",
      paddingBottom: "18px",
    },
    cardButtons: {
      paddingTop: "18px",
    },
    cardBuyButton: {
      textTransform: "capitalize",
      borderRadius: "16px",
      padding: "8px 16px",
    },
    topSection: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
    raffleTitle: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      justifyItems: 'space-between',
    },
    raffleSubtitle: {
      color: '#ff5f5f',
      marginLeft: '10px',
    },
    leftTitleSection: {
      paddingLeft: '20px',
      width: '10%',
      display: 'flex',
    },
    middleTitleSection: {
      width: '90%',
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
    },
    rightTitleSection: {
      width: '10%',
    },
    backButton: {
      color: theme.palette.common.black,
      backgroundColor: alpha('#ff5f5f', 0.8),
      '&:hover': {
        backgroundColor: alpha('#ff5f5f', 0.8),
      },
    },
    backButtonIcon: {},
    mainContent: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    prizesSection: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '300px',
      justifyContent: 'center',
      alignItems: 'center',
    },
    prizesHeader: {
      marginBottom: '10px',
    },
    seeAllPrizesButton: {
      marginLeft: '5px',
      color: '#ff5f5f',
      textTransform: 'initial',
      '&:hover': {
        textShadow: `0px 0px 5px ${'#ff5f5f'}`,
        backgroundColor: 'transparent',
        textDecoration: 'none',
      },
    },
    detailsSection: ({ device }) => ({
      paddingTop: '20px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      width: '60%',
      minWidth: device === DeviceType.Phone ? '256px' : '313px',
      maxWidth: device === DeviceType.Phone ? '380px' : '500px',
      maxHeight: '500px',
    }),
    actionSectionContainer: {
      width: '100%',
    },
    totalTickets: {
      marginRight: '80px',
    },
    prizeGallerySection: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    scrollIcon: {
      color: theme.palette.common.white,
      transform: `rotate(90deg)`,
      fontSize: '50px',
      opacity: '0.6',
      marginTop: '20px',
      marginBottom: '60px',
    },
    spacer: {
      width: '100%',
      height: '15px',
    },
  })
);
